import styled from 'styled-components'

const ExampleWrapper = styled.figure`
  background-color: #fff;
  padding: 20px;
`

export default ExampleWrapper
